import { Injectable } from "@angular/core";
import { Action, createSelector, Selector, State, StateContext } from "@ngxs/store";
import {
  defaultMultiTagSelectorState,
  MultiTagSelectorStateModel
} from "../model/multi-tag-selector-state.model";
import * as MultiTagSelectorActions from "./multi-tag-selector.action";

@State<MultiTagSelectorStateModel>({
  name: "multiTagSelector",
  defaults: defaultMultiTagSelectorState()
})
@Injectable()
export class MultiTagSelectorState {
  /**
   * Gets selected filter tags by tagTypeFriendlyId, if tagTypeFriendlyId is not provided, returns all selected tags
   * @param tagTypeFriendlyId
   * @returns
   */
  static getSelectedTagsByTagType(tagTypeFriendlyId?: string) {
    return createSelector([MultiTagSelectorState], (state: MultiTagSelectorStateModel) => {
      return tagTypeFriendlyId
        ? state.selectedTags.filter(t => t.tagTypeFriendlyId === tagTypeFriendlyId)
        : state.selectedTags;
    });
  }

  @Selector()
  public static currentState(state: MultiTagSelectorStateModel) {
    return state;
  }

  @Action(MultiTagSelectorActions.UpdateState)
  updateState(
    ctx: StateContext<MultiTagSelectorStateModel>,
    { state }: MultiTagSelectorActions.UpdateState
  ) {
    ctx.patchState(state);
  }

  @Action(MultiTagSelectorActions.AddSelectedTags)
  addSelectedTags(
    ctx: StateContext<MultiTagSelectorStateModel>,
    action: MultiTagSelectorActions.AddSelectedTags
  ) {
    const currentlySelected = ctx.getState().selectedTags;
    const toAdd = action.tagsToAdd.filter(
      t => !currentlySelected.map(t => t.tagId).includes(t.tagId)
    );

    if (toAdd.length > 0) {
      ctx.patchState({
        selectedTags: [...currentlySelected, ...toAdd]
      });
    }
  }

  @Action(MultiTagSelectorActions.RemoveSelectedTags)
  removeSelectedTags(
    ctx: StateContext<MultiTagSelectorStateModel>,
    action: MultiTagSelectorActions.RemoveSelectedTags
  ) {
    return ctx.patchState({
      selectedTags: ctx.getState().selectedTags.filter(t => !action.tagsToRemove.includes(t))
    });
  }
}
